const SPEED_KEY = 'yugioh.animSpeed'

export type AnimSpeedLevel = 1 | 2 | 3

function asLevel(value: number): AnimSpeedLevel {
  if (value <= 1) return 1
  if (value >= 3) return 3
  return 2
}

function readStored(): AnimSpeedLevel {
  try {
    const raw = localStorage.getItem(SPEED_KEY)
    if (raw === '1' || raw === '2' || raw === '3') return Number(raw) as AnimSpeedLevel
  } catch {
    /* ignore */
  }
  return 3
}

class AnimationSpeedManager {
  private speed: AnimSpeedLevel = readStored()

  setSpeed(s: number): void {
    this.speed = asLevel(s)
    try {
      localStorage.setItem(SPEED_KEY, String(this.speed))
    } catch {
      /* ignore */
    }
  }

  /** Cycles 1 → 2 → 3 → 1 (slow → normal → fast). */
  cycle(): AnimSpeedLevel {
    this.setSpeed((this.speed % 3) + 1)
    return this.speed
  }

  getSpeed(): AnimSpeedLevel {
    return this.speed
  }

  getDuration(ms: number): number {
    return Math.round(ms / this.speed)
  }
}

export const AnimationSpeed = new AnimationSpeedManager()
